import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

async function getSalesNavigatorContracts(
  workspaceId: string,
  accountId: string,
): Promise<{ name: string; description?: string }[]> {
  return (
    await get(
      `workspaces/${workspaceId}/accounts/${accountId}/sales-navigator/seats`,
    )
  ).seats;
}

export default function useSalesNavigatorContracts(accountId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { accountsKeys } = getQueryKeys(workspaceId);

  const {
    data: salesNavigatorContracts,
    isLoading: isLoadingSalesNavigatorContracts,
  } = useQuery({
    queryKey: accountsKeys.salesNavigatorContracts(accountId),
    queryFn: () => getSalesNavigatorContracts(workspaceId, accountId),
  });

  return { salesNavigatorContracts, isLoadingSalesNavigatorContracts };
}
